/**
 * Environment utility functions
 */

/**
 * Checks if the current environment is production
 * Based on Firebase project ID - 'justbaat-dev' indicates production
 */
export const isProd =
  // import.meta.env.VITE_FIREBASE_PROJECT_ID === 'justbaat-dev';
  true;

/**
 * Checks if the current environment is development
 */
export const isDev = !isProd;
